<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <router-view v-slot="{ Component }">
      <component :is="Component" v-if="Component" :is-edit="isEdit" :sitter-profile="sitterProfile">
        <slot />
      </component>
    </router-view>
  </div>
</template>

<script lang="ts">
export default {
  name: 'Availability',
  props: {
    sitterProfile: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
};
</script>
